import * as React from 'react';

import {Switch} from 'shells/switch/switch';
import {Body} from 'shells/typography/body';

import type {LicenseType} from 'nutshell-graphql-types';

import styles from './licensing.module.css';

type Props = {
    licenseType: LicenseType;
    isOn: boolean;
    handleSwitchToggle: (licenseType: LicenseType) => void;
    isDisabled: boolean;
};

export function SwitchContainer(props: Props) {
    return (
        <div className={styles['license-switch-container']}>
            <div className='flex justify-sb'>
                <Switch
                    isDisabled={props.isDisabled}
                    isOn={props.isOn}
                    isRounded={true}
                    onChange={() => props.handleSwitchToggle(props.licenseType)}
                />
                <Body>{props.isOn ? 'On' : 'Off'}</Body>
            </div>
        </div>
    );
}
